import Cookies from 'js-cookie';
import { defaultSettings } from '@/settings';
const tokenConfig = defaultSettings.token;
function getMainDomain() {
  const hostname = window.location.hostname;

  if (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname)
  ) {
    return undefined;
  }

  const parts = hostname.split('.');
  return parts.length > 2
    ? `.${parts.slice(-2).join('.')}`
    : hostname;
}

export function setCookie(
  key,
  value,
  options = {}
) {
  if (typeof value === 'object') {
    value = JSON.stringify(value);
  }
  Cookies.set(key, value, {
    path: '/',
    domain: getMainDomain(),
    secure: location.protocol === 'https:',
    sameSite: 'Lax',
    expires: tokenConfig.expires,
    ...options
  });
}

export function getCookie(key) {
  const value = Cookies.get(key);
  if (value) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }
  return null;
}

export function removeCookie(key) {
  Cookies.remove(key, {
    path: '/',
    domain: getMainDomain()
  });
}